// src/components/SignaturePad.js
import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

function SignaturePad({ label, onSignatureChange }) {
  const sigCanvasRef = useRef(null);
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);

  const handleEnd = () => {
    if (!sigCanvasRef.current) return;

    try {
      // Instead of trying to use getTrimmedCanvas which is causing the error,
      // just use the standard toDataURL directly on the canvas
      const signatureImage = sigCanvasRef.current.toDataURL("image/png");
      setTrimmedDataURL(signatureImage);
      onSignatureChange(signatureImage);
    } catch (error) {
      console.error("Error capturing signature:", error);
    }
  };

  const handleClear = () => {
    if (sigCanvasRef.current) {
      sigCanvasRef.current.clear();
      setTrimmedDataURL(null);
      onSignatureChange(null);
    }
  };

  return (
    <div style={{ marginBottom: "1rem" }}>
      <label>{label}</label>
      <div
        style={{
          width: "400px",
          height: "150px",
          border: "1px solid #ccc",
          backgroundColor: "#fafafa",
          margin: "8px 0",
        }}
      >
        <SignatureCanvas
          ref={sigCanvasRef}
          penColor="black"
          canvasProps={{ width: 400, height: 150, className: "sigCanvas" }}
          onEnd={handleEnd}
        />
      </div>
      <div style={{ marginTop: "8px" }}>
        <button
          type="button"
          onClick={handleClear}
          style={{ marginRight: "8px", marginBottom: "8px" }}
        >
          Clear Signature
        </button>
      </div>
      {trimmedDataURL && (
        <div style={{ marginTop: "8px" }}>
          <p>Preview:</p>
          <img
            src={trimmedDataURL}
            alt="Signature Preview"
            style={{ border: "1px solid #ccc", maxWidth: "400px" }}
          />
        </div>
      )}
    </div>
  );
}

export default SignaturePad;